import { HTTP as http } from '../http-common'

export default {
  async fetchColumns(currentPage,pageSize) {
    return await http.get(`/api/column?page=${currentPage}&size=${pageSize}`)
  },
  async fetchAllColumns(processId) {
    return await http.get(`/api/column/get-all?processId=` + processId)
  },
  async fetchDisplaySetting() {
    return await http.get(`/api/column/display_setting`)
  },
  async getColumnById(id) {
      return await http.get(`/api/column/${id}`)
  },
  async deleteColumns(ids) {
      return await http.delete("/api/column?ids=" + ids)
  },
  async updateColumn(payload,processId) {
    return await http.put("/api/column?processId=" + processId ,payload)
  },
  async createColumn(payload, processId) {
    return await http.post("/api/column?processId=" + processId ,payload)
  },
  async getColumn(){
    return await http.get("/api/column/get-all")
  }
}
  
